import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import {isSelected} from 'cl-table/redux/actions';
import * as _ from 'lodash';
import * as React from 'react';
import {useCallback} from 'react';
import {StoreState} from '../../../../App/initialStore';
import {getCategoryInfo} from '../../../../MyAccount/Listings/listingsHelper';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import connectWithRouter from '../../redux/connectWithRouter';
import createEbayCategoryField from '../DialogComponents/createEbayCategoryField';
import EbayAccountSelect from '../DialogComponents/EbayAccountSelect';
import EbaySiteSelect from '../DialogComponents/EbaySiteSelect';
import {Tables} from 'cl-api';

export interface PublishToEbayFormData {
  sellerId: string;
  site: string;
  categoryId: number;
}

const EbayCategoryField = createEbayCategoryField(GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_PAGE);

export type PublishToEbayDialogProps = SpecificFormDialogProps<
  PublishToEbayFormData,
  {defaultSellerId: string; firstProductTitle: string}
>;

function PublishToEbayDialog({defaultSellerId, firstProductTitle, ...props}: PublishToEbayDialogProps) {
  const asyncValidate = useCallback(async ({categoryId, site}) => {
    try {
      if (!categoryId || (await getCategoryInfo(categoryId, site)).selectedCategory) {
        return;
      }
    } catch (e) {
      // catch error
    }
    throw {categoryId: 'Valid category id is required'};
  }, []);
  return (
    <FormDialog<PublishToEbayFormData>
      formName={GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_PAGE}
      initialValues={{sellerId: defaultSellerId, site: 'US'}}
      title="Publish to eBay"
      asyncValidate={asyncValidate}
      asyncChangeFields={['categoryId', 'site']}
      fields={[
        {component: EbayAccountSelect, name: 'sellerId', label: 'eBay account'},
        {component: EbaySiteSelect, name: 'site', label: 'Site'},
        {component: EbayCategoryField, name: 'categoryId', props: {listingTitle: firstProductTitle}},
      ]}
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_PAGE]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          lastActionColor="primary"
        />
      }
      {...props}
    />
  );
}

export default connectWithRouter((state: StoreState) => {
  const tableState = state.table[Tables.InventoryTable];
  return {
    defaultSellerId: _.first(_.keys(state.accountPage.accounts)),
    firstProductTitle: tableState.data.find((product, index) => isSelected(tableState, index), null, {}).Title,
  };
})(PublishToEbayDialog);
